function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_20030483_92023)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M42.4267 35.5733L49.456 24.8373L48.2453 23.7547L38.4507 32.0187C36.6507 31.6507 34.712 32.2 33.4 33.6667C31.4373 35.8613 31.6267 39.2347 33.824 41.1973C36.0213 43.16 39.392 42.9707 41.3547 40.7733C42.6667 39.3067 42.9947 37.32 42.4267 35.5733V35.5733ZM32 7.184V0H42.6667V7.184C38.8293 6.536 35.7547 6.54933 32 7.184ZM55.6027 12.688L59.3547 8.936L63.1253 12.7067L59.6027 16.2293C58.3707 14.9387 57.032 13.7573 55.6027 12.688V12.688ZM5.33333 24H26.6667V29.3333H5.33333V24ZM0 34.6667H21.3333V40H0V34.6667ZM8 45.3333H26.6667V50.6667H8V45.3333ZM64 37.3333C64 52.0613 52.0613 64 37.3333 64C29.8933 64 23.2 60.92 18.3707 56H27.1173C30.152 57.6827 33.6213 58.6667 37.3333 58.6667C49.096 58.6667 58.6667 49.096 58.6667 37.3333C58.6667 25.5707 49.096 16 37.3333 16C33.6213 16 30.152 16.984 27.1173 18.6667H18.3707C23.2 13.7467 29.8933 10.6667 37.3333 10.6667C52.0613 10.6667 64 22.6053 64 37.3333Z",
  fill: "url(#paint0_linear_20030483_92023)"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_20030483_92023",
  x1: 64.5,
  y1: 32,
  x2: -3,
  y2: 36,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#02E1B3"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#02E1B3",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_20030483_92023"
}, /*#__PURE__*/React.createElement("rect", {
  width: 64,
  height: 64,
  fill: "white"
})));

function SvgConfirm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirm);
export default __webpack_public_path__ + "static/media/confirm.a3afac2d67474f141bdcacf7c463e4b4.svg";
export { ForwardRef as ReactComponent };